import { useQuery } from '@tanstack/react-query';
import { fetchKnowledgeLawCountries } from '../services/knowledgeLawCountries';

export function useRegulationCountries(enabled: boolean) {
  const countriesQuery = useQuery({
    queryKey: ['knowledge-law-countries'],
    queryFn: fetchKnowledgeLawCountries,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    countries: countriesQuery.data || [],
    isLoading: countriesQuery.isLoading,
    hasError: Boolean(countriesQuery.error),
  };
}
